<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.prepaid && prepaidReasons && wrapper">
    <div style="max-width:1200px;" class="banner center">
        <div class="row freeze_height">
            <div class="col-md-4">
                <ngx-select *ngIf="localService.countryCodes && (businessId == '' || businessId == '0')"
                    [(ngModel)]="reqCtryCode" [optionValueField]="'v2'" [optionTextField]="'v1'"
                    [items]="localService.countryCodes" (select)="onLoad()" [noAutoComplete]="true">
                </ngx-select>
            </div>
            <div class="col-md-4">
                <ngx-select *ngIf="interactionTypes && (businessId == '' || businessId == '0')"
                    [(ngModel)]="reqInteractionType" [optionValueField]="'key'" [optionTextField]="'value'"
                    [items]="interactionTypes" (select)="onLoad()" [noAutoComplete]="true">
                </ngx-select>
            </div>
            <div class="col-md-4">
                <ngx-select [items]="prepaidReasons" [optionValueField]="'key'" [optionTextField]="'value'"
                    [(ngModel)]="prepaidReason" (select)="onLoad()" [noAutoComplete]="true"
                    placeholder="{{localService.languageContent.prepaid.reason}}"
                    title="{{localService.languageContent.prepaid.reason}}" [allowClear]="true" (remove)="onLoad()">
                </ngx-select>
            </div>
        </div>
        <div class="row row_header freeze_col freeze_height">
            <div class="col-3">
                <span>{{localService.languageContent.prepaid.created_on}}</span>
            </div>
            <div class="col-2">
                <span>{{localService.languageContent.common.upi}}</span>
            </div>
            <div class="col-2">
                <span>{{localService.languageContent.prepaid.amount}}</span>
            </div>
            <div class="col-5">
                <span>{{localService.languageContent.prepaid.reason}}</span>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row" *ngFor="let item of wrapper.items">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-6 en">
                            {{item.v1 | localDate}}
                        </div>
                        <div class="col-6">
                            <i class="material-icons icon_adjust"
                                style="color:gray;">{{localService.onGetIcon(item.v6)}}</i>
                            <span class="en button"
                                (click)="localService.showSummary(item.v7, localService.onGetSummaryType(item.v6))">&nbsp;{{item.v3}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-6" style="text-align:right;">
                            <span class="en">{{item.v2 | number: '1.2-2'}}</span>
                        </div>
                        <div class="col-6">
                            <span>{{localService.getText(prepaidReasons,item.v4)}}</span>
                            <span class="en" *ngIf="item.v8 != ''">&nbsp;({{item.v8}})</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging [paging]="wrapper.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>